import { initializeStores } from "~/assets/utils/storeAccessor";

export default ({ store }) => {
  // with this plugin we can initialize the stores in the context of the app
  initializeStores(store);
};
